import * as DialogPrimitive from "@radix-ui/react-dialog";
import { DocumentUploader } from "./DocumentUploader";

interface DocumentUploadDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
}

export function DocumentUploadDialog({
    open,
    onOpenChange,
}: DocumentUploadDialogProps) {
    return (
        <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
            <DialogPrimitive.Portal>
                <DialogPrimitive.Overlay className="data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50" />
                <DialogPrimitive.Content className="bg-md-surface data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed top-[50%] left-[50%] z-50 max-h-[80vh] w-full max-w-[calc(100%-2rem)] translate-x-[-50%] translate-y-[-50%] overflow-hidden rounded-lg shadow-lg duration-200 sm:max-w-[500px] flex">
                    <DocumentUploader
                        onClose={() => onOpenChange(false)}
                        className="max-w-none max-h-full"
                        elevation={0}
                    />
                </DialogPrimitive.Content>
            </DialogPrimitive.Portal>
        </DialogPrimitive.Root>
    );
}
